// extracted by mini-css-extract-plugin
export default {"body":"partners_body__AMAYh","thanks":"partners_thanks__MIdhD","jumbotron":"partners_jumbotron__MFLfH"};